module.exports = __webpack_public_path__ + "img/BE.057b69d9.png";